(function () {
  'use strict';
  var root = window.ZOREX || {};
  var moneyFormat = root.moneyFormat || '${{amount_no_decimals_with_comma_separator}}';

  function formatMoney(cents) {
    cents = Math.round(cents);
    var value = cents / 100;
    function sep(n, dec, thou, dp) {
      var parts = n.toFixed(dp).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(dec);
    }
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return sep(value, '.', ',', 2);
        case 'amount_no_decimals': return sep(value, '.', ',', 0);
        case 'amount_with_comma_separator': return sep(value, ',', '.', 2);
        case 'amount_no_decimals_with_comma_separator': return sep(value, ',', '.', 0);
        case 'amount_with_apostrophe_separator': return sep(value, '.', "'", 2);
        default: return sep(value, ',', '.', 0);
      }
    });
  }

  /* Toggles: menú, búsqueda, filtros */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    var target = document.getElementById(t.getAttribute('data-toggle'));
    if (!target) return;
    var open = target.classList.toggle('is-open');
    t.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) { var f = target.querySelector('input'); if (f && t.hasAttribute('data-focus')) f.focus(); }
  });

  /* Toast */
  var toastTimer;
  function toast(html) {
    var el = document.getElementById('zx-toast');
    if (!el) return;
    el.innerHTML = html;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 2600);
  }

  window.ZX_updateCartCount = function () { updateCartCount(); };
  function updateCartCount() {
    fetch((root.routes && root.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
      }).catch(function () {});
  }

  /* Agregar al carrito vía AJAX (tarjetas y ficha de producto) */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('form[data-ajax-cart]')) return;
    if (form.dataset.buyNow === '1') return; // "Comprar ahora" sigue el flujo normal hacia el checkout
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if (btn) btn.disabled = true;
    var err = form.querySelector('[data-error]');
    if (err) err.textContent = '';
    fetch((root.routes && root.routes.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.d.description || res.d.message || 'No se pudo agregar');
        updateCartCount();
        if (window.ZX_afterAdd) { window.ZX_afterAdd(); }
        else toast((root.strings && root.strings.added || 'Agregado al carrito') +
          ' <a href="' + (root.routes && root.routes.cart || '/cart') + '">' + (root.strings && root.strings.viewCart || 'Ver carrito') + '</a>');
      })
      .catch(function (ex) { if (err) err.textContent = ex.message; else toast(ex.message); })
      .finally(function () { if (btn && !btn.hasAttribute('data-soldout')) btn.disabled = false; });
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-buy-now]');
    if (!b) return;
    var form = document.getElementById(b.getAttribute('data-buy-now'));
    if (!form) return;
    e.preventDefault();
    var ret = form.querySelector('input[name=return_to]');
    if (!ret) { ret = document.createElement('input'); ret.type = 'hidden'; ret.name = 'return_to'; form.appendChild(ret); }
    ret.value = '/checkout';
    form.dataset.buyNow = '1';
    form.submit();
  });

  /* Cantidad */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var v = parseInt(input.value, 10) || 1;
    v = b.getAttribute('data-qty') === '+' ? v + 1 : Math.max(1, v - 1);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Galería */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var slides = g.querySelectorAll('.gallery__slide');
    var thumbs = g.querySelectorAll('.gallery__thumb');
    var counter = g.querySelector('.gallery__counter');
    var i = 0;
    function show(n) {
      if (!slides.length) return;
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (counter) counter.textContent = (i + 1) + ' / ' + slides.length;
    }
    g._show = function (mediaId) {
      slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(mediaId)) show(k); });
    };
    var prev = g.querySelector('.gallery__nav--prev');
    var next = g.querySelector('.gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { show(i - 1); });
    if (next) next.addEventListener('click', function () { show(i + 1); });
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var sx = null;
    g.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    g.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
      sx = null;
    });
  });

  /* Variantes */
  document.querySelectorAll('[data-product-json]').forEach(function (script) {
    var product;
    try { product = JSON.parse(script.textContent); } catch (e) { return; }
    var section = script.closest('[data-product-section]');
    if (!section) return;
    var form = section.querySelector('form[data-ajax-cart]');
    var idInput = form && form.querySelector('input[name=id]');
    var fieldsets = section.querySelectorAll('fieldset[data-option-index]');
    var cuotasN = parseInt(section.getAttribute('data-cuotas') || '0', 10);

    function current() {
      var sel = [];
      fieldsets.forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        sel[parseInt(fs.getAttribute('data-option-index'), 10)] = c ? c.value : null;
      });
      return product.variants.find(function (v) {
        return v.options.every(function (o, k) { return o === sel[k]; });
      });
    }

    function markAvailability() {
      fieldsets.forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('input').forEach(function (inp) {
          var others = [];
          fieldsets.forEach(function (f2) {
            var j = parseInt(f2.getAttribute('data-option-index'), 10);
            var c = f2.querySelector('input:checked');
            others[j] = j === idx ? inp.value : (c ? c.value : null);
          });
          var ok = product.variants.some(function (v) {
            return v.available && v.options.every(function (o, k) { return o === others[k]; });
          });
          var label = fs.querySelector('label[for="' + inp.id + '"]');
          if (label) label.classList.toggle('is-unavailable', !ok);
        });
      });
    }

    function update() {
      var v = current();
      var btn = form && form.querySelector('[type=submit]');
      var buyNow = section.querySelector('[data-buy-now]');
      markAvailability();
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); }
        if (buyNow) buyNow.disabled = true;
        return;
      }
      if (idInput) idInput.value = v.id;
      var now = section.querySelector('[data-price-now]');
      var was = section.querySelector('[data-price-was]');
      var off = section.querySelector('[data-price-off]');
      var cuotas = section.querySelector('[data-cuotas-text]');
      if (now) now.textContent = formatMoney(v.price);
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      if (was) { was.textContent = hasCompare ? formatMoney(v.compare_at_price) : ''; was.hidden = !hasCompare; }
      if (off) {
        off.hidden = !hasCompare;
        if (hasCompare) off.textContent = Math.round((1 - v.price / v.compare_at_price) * 100) + '% OFF';
      }
      if (cuotas && cuotasN > 0) cuotas.textContent = cuotas.getAttribute('data-template')
        .replace('[n]', cuotasN).replace('[monto]', formatMoney(v.price / cuotasN));
      if (btn) {
        btn.disabled = !v.available;
        if (v.available) btn.removeAttribute('data-soldout'); else btn.setAttribute('data-soldout', '');
        var qi = form.querySelector('input[name=quantity]');
        btn.textContent = v.available ? btn.getAttribute('data-available').replace('[q]', qi ? qi.value : 1) : btn.getAttribute('data-soldout-text');
      }
      section.dispatchEvent(new CustomEvent('zx:variant', { detail: v, bubbles: true }));
      if (buyNow) buyNow.disabled = !v.available;
      if (v.featured_media) {
        var g = section.querySelector('[data-gallery]');
        if (g && g._show) g._show(v.featured_media.id);
      }
      if (window.history.replaceState && section.hasAttribute('data-update-url')) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
    if (fieldsets.length) markAvailability();
  });

  /* Filtros de colección: enviar al cambiar */
  document.querySelectorAll('form[data-autosubmit]').forEach(function (f) {
    f.addEventListener('change', function () { f.submit(); });
  });

  /* Carrito: actualizar al cambiar cantidad */
  document.querySelectorAll('form[data-cart-form] input[name="updates[]"]').forEach(function (inp) {
    inp.addEventListener('change', function () { inp.form.submit(); });
  });

  /* Recomendaciones de producto */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var tmp = document.createElement('div');
      tmp.innerHTML = text;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });
})();
